<template>
<div id="layouts_activo_fijo" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Etiquetado Código QR" class="elevation-1 px-5 py-3" >
                    <br>
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab key="cargar_etiquetas">Generar Etiquetas QR</v-tab>
                        <v-tab key="consultar_etiquetas">Consulta/Modificación de Etiquetas QR</v-tab>
                        
                        <v-tab-item key="cargar_etiquetas" >
                            <div class="contenedor-tab-reportes" >
                                <v-card-text>
                                <v-card-title>
                                    <span class="headline" ></span>
                                </v-card-title>
                                
                                </v-card-text>
                                
                                <v-card-text>
                                    <v-row>
                                        <v-alert color="black" dense dark outlined text style="font-size:11px !important">
                                            Los campos de identificacion del Activo Fijo son Planta/Referencia y Maquina, estos deberan de ser únicos y no relaccionarse a más de un pedimento.
                                        </v-alert>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6" >
                                            <v-row>
                                                <v-col sm="10" md="10" lg="10" >
                                                    1.- Descargar Layout Pedimento para generar etiquetado QR:
                                                </v-col>
                                                <v-col sm="1" md="1" lg="1" >
                                                    <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout_Etiquetado.xlsx" >
                                                    <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                                        <v-icon dark>receipt</v-icon>
                                                    </v-btn>
                                                </exportar-excel>
                                                </v-col>                                        
                                            </v-row>                                        
                                            <v-row>
                                                <v-col sm="10" md="10" lg="10" >
                                                    2.- Carga de Layout de Pedimento:
                                                </v-col>
                                                <v-col sm="1" md="1" lg="1" >
                                                    <upload-excel-component idInput="pedimentosKey" :on-success="handleSuccess" :before-upload="beforeUpload" />
                                                </v-col>                                                
                                            </v-row>
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6" >
                                            <!--v-row dense>
                                                <v-col>
                                                    <v-switch color="primary" label="Agregar código de acceso para visualizar expediente" v-model="con_password" 
                                                        :true-value="1" :false-value="0" @change="password='';"></v-switch>
                                                </v-col>
                                            </v-row-->  
                                            <v-row dense>
                                                <span>Código de acceso para visualizar expediente</span>
                                            </v-row>
                                            <v-row dense>
                                                <v-col sm="6" md="6" lg="6" >
                                                    <v-text-field v-model="password" label="Ingrese Código de Acceso" maxlength="10"
                                                        :rules="[validaPassword]" ></v-text-field>
                                                </v-col>
                                                <v-col sm="6" md="6" lg="6" >
                                                    <v-btn color="success" fab x-small @click="confirma_guardar_codigo(1)" title="Establecer Código">
                                                        <v-icon>done</v-icon>
                                                    </v-btn>&nbsp;
                                                    <v-btn color="pink" fab x-small @click="confirma_guardar_codigo(0)" title="Eliminar Código">
                                                        <v-icon>delete</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col sm="8" md="8" lg="8" >
                                                    NOTA: Una vez ingresado el código de acceso, este mismo aplicará para la lectura del Código QR de las etiquetas ya generadas y las próximas a generar. Adicional a eso, al eliminar el Código de Acceso se eliminará en todas las etiquetas generadas y las próximas a generar.
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    
                                        
                                
                                </v-card-text>

                                <v-card-text>
                                    <v-card-actions>
                                        <v-refresh-button :funcion="cargar" />
                                        <v-spacer></v-spacer>
                                            <v-btn small color="blue" title="ZIP Plantillas Cargadas" 
                                                @click="descarga_zip_plantillas()" >
                                                ZIP Plantillas Cargadas
                                            </v-btn>
                                    </v-card-actions>

                                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="secondary" title="Etiquetas QR" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                            <v-icon dark>label</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="success" title="Pedimentos" @click="getTablaPedimentos(props.row.id)" >
                                            <v-icon dark>folder</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="red" title="Eliminar" @click="eliminarReporte(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                    </v-client-table>
                                </v-card-text>

                            </div>     
                        </v-tab-item>
                        <v-tab-item key="consultar_etiquetas" >
                            <br>
                            <v-card-text>
                                FILTROS:
                                <v-row row wrap>
                                    <v-col sm="12" md="4" lg="4" >
                                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }" >
                                        <v-text-field v-on="on" v-model="model_busqueda.fecha_de" clearable label="Fecha Inicial Pedimento" color="secondary" prepend-icon="event" @blur="model_busqueda.fecha_de = parseDate(model_busqueda.fecha_de)" v-mask="'####-##-##'"
                                            :rules="[validaAnio, validaFecha]" ></v-text-field>
                                        </template>

                                        <v-date-picker v-model="model_busqueda.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu1 = false" >
                                            Cancelar
                                        </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                    </v-col>
                                    <v-col sm="12" md="4" lg="4" >
                                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }" >
                                        <v-text-field v-on="on" v-model="model_busqueda.fecha_a" clearable label="Fecha Final Pedimento" color="secondary" prepend-icon="event" @blur="model_busqueda.fecha_a= parseDate(model_busqueda.fecha_a)" v-mask="'####-##-##'"
                                            :rules="[validaAnio, validaFecha]" ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="model_busqueda.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu2 = false" >
                                            Cancelar
                                        </v-btn>
                                        </v-date-picker>
                                    </v-menu>

                                    </v-col>
                                    <v-col sm="12" md="4" lg="4" >
                                        <v-text-field v-model="model_busqueda.pedimento" clearable label="No Pedimento"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" lg="3" md="3">
                                        <v-autocomplete v-model="model_busqueda.planta" :items="plantas_arr" :hide-no-data="true" 
                                            :return-object="false" label="Planta" clearable :loading="loadingPlantas">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" lg="3" md="3">
                                        <v-autocomplete v-model="model_busqueda.edificio" :items="edificios_arr" :hide-no-data="true" 
                                            :return-object="false" label="Edificio" clearable :loading="loadingEdificios">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" lg="3" md="3">
                                        <v-autocomplete v-model="model_busqueda.linea" :items="lineas_arr" :hide-no-data="true" 
                                            :return-object="false" label="Línea" clearable :loading="loadingLineas">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" lg="3" md="3">
                                        <v-text-field v-model="model_busqueda.maquina" clearable label="No Maquina"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="buscar()" >
                                    <v-icon>search</v-icon>Buscar
                                </v-btn>
                                &nbsp;
                                <exportar-excel :data="datos_etiquetas" v-show="datos_etiquetas.length>0"
                                    :exportFields="data_busqueda_excel" name="Información_Etiquetas.xlsx" >
                                    <v-btn color="success" title="Exportar Excel" v-tippy>
                                        <v-icon dark>get_app</v-icon> Excel
                                    </v-btn>
                                </exportar-excel>
                            </v-card-actions>
                            </v-card-text>
                            

                            <v-card-text>
                                <v-client-table ref="vuetable_etiquetas" :data="datos_etiquetas" :columns="columnsEtiquetas" 
                                    :options="optionsEtiquetas" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="secondary" title="Etiqueta QR" @click="downloadQr(props.row)" >
                                            <v-icon dark>label</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="success" title="Editar" @click="editar(props.row)" >
                                            <v-icon dark>edit</v-icon>
                                        </v-btn>                                        
                                    </template>
                                    </v-client-table>
                            </v-card-text>


                        </v-tab-item>
                    </v-tabs>                                                                   
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="modal_pedimentos" max-width="80%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" @click.native="modal_pedimentos = false">
                        cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Pedimentos</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>                
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <exportar-excel :data="data_resumen" :exportFields="data_resumen_excel" name="Etiquetas_pedimentos.xlsx" >
                    <v-btn dark small color="success" title="Exportar Detalle" v-tippy>
                        <v-icon dark>get_app</v-icon> Exportar Detalle
                    </v-btn>
                </exportar-excel>                
            </v-card-actions>
            <v-card-text>       
                <v-client-table ref="vuetabledetalle" :data="data_resumen" :columns="columns_resumen" :options="options_resumen" class="elevation-2 pa-2" >
                    <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                    </template>
                    <template slot="URL" slot-scope="props">
                        <a :href="props.row.URL" target="_blank">{{props.row.URL}}</a>
                    </template>
                    
                </v-client-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal_pedimentos = false" >
                    <v-icon>cancel</v-icon>Cerrar
                </v-btn>                                
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" @click.native="modal = false">
                        cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Editar Etiqueta QR</strong>
                    </span>
                </v-card>                
            </v-card-title>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                        <v-row>
                            <v-col sm="6" md="6" lg="6">
                                <v-text-field label="Planta/Referencia" type="text" v-model="model_editable.planta_referencia" 
                                :rules="[rules.required]" readonly disabled></v-text-field>
                            </v-col>
                            <v-col sm="6" md="6" lg="6">
                                <v-text-field label="No. Maquina" type="text" v-model="model_editable.no_maquina" 
                                :rules="[rules.required]" readonly disabled></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col sm="4" md="4" lg="4">
                                <v-text-field label="Pedimento" type="text" v-model="model_editable.pedimento" 
                                :rules="[rules.required]" maxlength="20"></v-text-field>
                            </v-col>
                            <v-col sm="4" md="4" lg="4">
                                <v-text-field label="Año" type="text" v-model="model_editable.anio" 
                                :rules="[rules.required]" maxlength="4"></v-text-field>
                            </v-col>
                            <v-col sm="4" md="4" lg="4">
                                <v-text-field label="Edificio" type="text" v-model="model_editable.edificio" 
                                :rules="[rules.required]" maxlength="200"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col sm="4" md="4" lg="4">
                                <v-text-field label="Línea" type="text" v-model="model_editable.linea" 
                                :rules="[rules.required]" maxlength="200"></v-text-field>
                            </v-col>
                            <v-col sm="4" md="4" lg="4">
                                <v-text-field label="Marca" type="text" v-model="model_editable.marca" 
                                maxlength="200"></v-text-field>
                            </v-col>
                            <v-col sm="4" md="4" lg="4">
                                <v-text-field label="Modelo" type="text" v-model="model_editable.modelo" 
                                maxlength="200"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col sm="4" md="4" lg="4">
                                <v-text-field label="Serie" type="text" v-model="model_editable.serie" 
                                maxlength="200"></v-text-field>
                            </v-col>
                            <v-col sm="8" md="8" lg="8">
                                <v-text-field label="Descripción" type="text" v-model="model_editable.descripcion" 
                                maxlength="200"></v-text-field>
                            </v-col>                            
                        </v-row>
                        <v-row>
                            <v-col sm="4" md="4" lg="4">
                                <v-autocomplete v-model="model_editable.estatus" :items="estatus_arr" :hide-no-data="true" 
                                    :return-object="false" label="Estatus" :rules="[rules.required]">                                    
                                </v-autocomplete>                                
                            </v-col>
                            <v-col sm="8" md="8" lg="8">
                                <v-text-field label="Observaciones" type="text" v-model="model_editable.observaciones" 
                                maxlength="300"></v-text-field>
                            </v-col>                            
                        </v-row>
                        
                    </v-container>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="guardar()" >
                    <v-icon>done</v-icon> Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!--v-dialog v-model="modal_qr" max-width="35%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" @click.native="modal_qr = false">
                        cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Etiqueta QR</strong>
                    </span>
                </v-card>                
            </v-card-title>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-container class="text-center" grid-list-md text-xs-center >
                        <v-row>                            
                                <v-text-field label="Texto" v-model="leyenda_qr" ></v-text-field>                                                        
                        </v-row>
                        <v-row align="center" justify="center"> 
                            <v-col lg="4" md="4" sm="4">
                                &nbsp;
                            </v-col>
                            <v-col lg="4" md="4" sm="4">
                                <div id="html_codigo_qr" style="height: 105px; width: 133.29px;font-family: 'Arial';font-size: 0.75rem;">
                                                                
                                    <table width="133.29px" style="border-collapse:collapse; page-break-inside: avoid;">
                                        <tr >
                                            <td width="133.29px" align="center" justify="center">
                                                
                                                    
                                                            
                                                                <img :src="codigo_qr" width="55%" style="margin-left:0px; margin-top:11px; margin-bottom:-1px !important;padding:0px !important;">
                                                            
                                                            <div style="margin-left:6px;margin-right:6px;line-height: 130%;font-family:'Arial';font-size: 0.4rem !important;margin-top:0px !important;padding:0px !important;">
                                                                {{leyenda_qr}}
                                                            </div>                                                        
                                            </td>	
                                        </tr>		
                                    </table>	
                                </div>     
                            </v-col>
                            <v-col lg="4" md="4" sm="4">
                                &nbsp;
                            </v-col>
                        </v-row>                          
                        
                    </v-container>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="success" @click.native="descargar_qr()" >
                    <v-icon>mdi-arrow-down</v-icon> Descargar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog-->

    <v-dialog v-model="modal_qr" max-width="60%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" @click.native="modal_qr = false">
                        cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Etiqueta QR</strong>
                    </span>
                </v-card>                
            </v-card-title>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-container class="text-center" grid-list-md text-xs-center >
                        <v-row>                            
                            <v-col lg="12" md="12" sm="12">
                                <v-text-field label="Texto Linea 1" v-model="leyenda_qr" ></v-text-field>                                
                            </v-col>
                            <v-col lg="12" md="12" sm="12">
                                <v-text-field label="Texto Linea 2" v-model="leyenda_qr2" ></v-text-field>                                
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center"> 
                            <v-col lg="3" md="3" sm="3">
                                <v-text-field label="Tamaño texto" v-model="textSize" ></v-text-field>
                                <v-text-field label="Tamaño texto Planta/Maquina" v-model="textSizePlanta" ></v-text-field>
                                <v-text-field label="Ancho QR en cm" v-model="width" v-on:input="updateSize" ></v-text-field>
                                <v-text-field label="Alto QR en cm" v-model="height" v-on:input="updateSize" ></v-text-field>                                
                            </v-col>
                            <v-col lg="3" md="3" sm="3">
                                <v-text-field label="Margen arriba en cm" v-model="marginTop" v-on:input="updateSize" ></v-text-field>
                                <v-text-field label="Margen abajo en cm" v-model="marginBottom" v-on:input="updateSize" ></v-text-field>
                                <v-text-field label="Margen izquierdo en cm" v-model="marginLeft" v-on:input="updateSize" ></v-text-field>
                                <v-text-field label="Margen derecho en cm" v-model="marginRight" v-on:input="updateSize" ></v-text-field>
                            </v-col>
                            <v-col lg="6" md="6" sm="6">
                                <div id="html_codigo_qr" :style="{padding:'0px', fontFamily: 'Arial', border: borderCuadro +'px dotted black'}" >
                                                                
                                    
                                    <!--table width="90%" style="border-collapse:separate; border-spacing: 10px 5px; ">
                                        <tr>
                                            <td width="100%" style="text-align:center;"--> 
                                            <div :style="{marginTop: marginTopPX + 'px', marginLeft: marginLeftPX + 'px', marginBottom: marginBottomPX + 'px', marginRight: marginRightPX + 'px', padding:'0px'}">
                                                <!--img :src="codigo_qr" :style="{width: widthPX + 'px', height: heightPX + 'px', marginTop: marginTopPX + 'px', marginLeft: marginLeftPX + 'px', marginBottom: '0 px', marginRight: marginRightPX + 'px', padding:'0px'}" />
                                                
                                                <div :style="{marginLeft: marginLeftPX + 'px', marginBottom: '5px', marginRight: marginRightPX + 'px', fontSize: textSize + 'rem', lineHeight: '130%', fontFamily:'Arial', marginTop:'0px !important', padding:'0px !important;'}">
                                                    {{leyenda_qr}}<br>
                                                    {{leyenda_qr2}}
                                                </div-->
                                                <div style="border: 1px solid black;">
                                                    <img :src="codigo_qr" :style="{width: widthPX + 'px', height: heightPX + 'px', padding:'0px'}" />
                                                    
                                                    <div :style="{fontSize: textSize + 'rem', lineHeight: '130%', fontFamily:'Arial', padding:'0px !important;'}">
                                                        {{leyenda_qr}}<br>
                                                        {{leyenda_qr2}}
                                                    </div>
                                                </div>
                                                

                                                <div :style="{fontSize: textSizePlanta + 'rem', marginTop: '5px', lineHeight: '130%', fontFamily:'Arial', }">
                                                    <strong>{{leyenda_planta}}<br>
                                                    {{leyenda_maquina}}</strong>
                                                </div>
                                            
                                            </div>
                                            <!--/td>
                                        </tr>                                                
                                    </table-->
                                            
                                </div>     
                            </v-col>                            
                        </v-row>                          
                        
                    </v-container>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="success" @click.native="descargar_qr()" >
                    <v-icon>mdi-arrow-down</v-icon> Descargar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

window.html2canvas = html2canvas
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },

data: () => ({
        file_adjunto: null,
        estatus_arr:["ACTIVO","INACTIVO"],
        password:"",
        con_password:0,
        borderCuadro:1,
        textSize: 0.45,
        textSizePlanta: 0.8,
        width: 5,
        height: 5,
        marginTop: .5,
        marginBottom: .5,
        marginLeft: .5,
        marginRight: .5,
        widthPX : 0,
        heightPX : 0,
        marginTopPX : 0,
        marginBottomPX : 0,
        marginLeftPX : 0,
        marginRightPX : 0,
        leyenda_qr:"",
        leyenda_qr2:"",
        leyenda_planta:"",
        leyenda_maquina:"",
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        URL:"",        
        data_resumen:[],
        data_busqueda_excel: {
            "Solicitado":"solicitado",
            "Usuario":"usuario",
            "Tipo Operación":"tipo_operacion",
            "Patente":"patente",
            "Sección Aduanera":"seccion_aduanera",
            "Número Pedimento":"pedimento",
            "Fecha Pago Real":"fecha_pago_real",
            "Fecha Entrada":"fecha_entrada",
            "Año":"anio",
            "Clave Documento":"clave_documento",
            "Maquina No.":"no_maquina",
            "Línea":"linea",
            "Marca":"marca",
            "Modelo":"modelo",
            "Descripción":"descripcion",
            "Serie":"serie",
            "Observaciones":"observaciones",
            "Edificio":"edificio",
            "Estatus":"estatus",
            "Planta":"planta_referencia",
            "Error":"error",
            "URL":"URL"
        },
        data_resumen_excel: {
            "Tipo Operación":"tipo_operacion",
            "Patente":"patente",
            "Sección Aduanera":"seccion_aduanera",
            "Número Pedimento":"pedimento",
            "Fecha Pago Real":"fecha_pago_real",
            "Fecha Entrada":"fecha_entrada",
            "Año":"anio",
            "Clave Documento":"clave_documento",
            "Maquina No.":"no_maquina",
            "Línea":"linea",
            "Marca":"marca",
            "Modelo":"modelo",
            "Descripción":"descripcion",
            "Serie":"serie",
            "Observaciones":"observaciones",
            "Edificio":"edificio",
            "Estatus":"estatus",
            "Planta":"planta_referencia",
            "Error":"error",
            "URL":"URL"
        },
        columns_resumen: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento",
            "no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia"
            ,"error","URL"],
        options_resumen: {
            filterable: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento","no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia"
            ,"error","URL"],
            sortable: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento","no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia","error","URL"],
            headings: {
                tipo_operacion:"Tipo Operacion",
                patente:"patente",
                seccion_aduanera:"Sección Aduanera",
                numero_pedimento:"Número Pedimento",
                fecha_pago_real:"Fecha Pago Real",
                fecha_entrada:"Fecha Entrada",
                anio:"Año",
                clave_documento:"Clave Documento",
                "no_maquina":"Maquina No.",
                "planta_referencia":"Planta",
                marca:"Marca",
                modelo:"Modelo",
                serie:"Serie",
                informacion:"Información",
                error:"Error",
            }
        },
        modal_pedimentos:false,
        permisoEliminar: false,
        menu1: false,
        menu2: false,
        plantas_arr: [],
        edificios_arr: [],
        lineas_arr: [],
        codigo_qr:"",
        modal:false,
        modal_qr:false,
        model_editable:{
            pedimento: "",
            anio: "",
            no_maquina: "",
            linea: "",
            marca: "",
            modelo: "",
            descripcion: "",
            serie: "",
            observaciones: "",
            edificio: "",
            estatus: "",
            planta_referencia:""
        },
        model_busqueda:{
            fecha_de:"",
            fecha_a:"",
            planta:"",
            maquina:"",
            edificio:"",
            linea:"",
            pedimento:"",
        },
        name: "datagrid",
        importData: [],
        arrClaves:[],        
        URL: "",

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Información de Contenido de Pedimentos",
                disabled: false,
                to: "/reportes/informacion_activo"
            },
            {
                text: "Interfaz de Identificación AF_FILE",
                disabled: false,
                to: "/reportes/layouts_activofijo"
            },
            {
                text: "Reporte Activo Fijo",
                disabled: false,
                to: "/reportes/activofijo"
            },            
            {
                text: "Etiquetado Código QR",
                disabled: true,
                to: ""
            }
        ],
        loadingPlantas:false,
        loadingEdificios:false,
        loadingLineas:false,
        datos: [],
        datos_etiquetas:[],
        columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "fecha_generacion", "estatus", "error"],
            sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "fecha_generacion", "estatus", "error"],

            headings: {
                id: "No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",            
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Opciones"
            }
        },
        columnsEtiquetas: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error", "actions"],
        optionsEtiquetas: {
            filterable: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error"],
            sortable: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error"],

            headings: {
                "planta_referencia":"Planta", 
                "no_maquina":"No. Maquina", 
                "edificio":"Edificio", 
                "linea":"Línea", 
                "fecha_pago_real":"Fecha Pedimento", 
                "pedimento":"No. Pedimento",
                actions: "Opciones"
            }
        },
                
        
        encabezadoLayout: {
            pedimento: "pedimento",
            "año":"año",     
            "no_maquina":"no_maquina",
            "linea":"linea",
            marca:"marca",
            modelo:"modelo",
            "descripcion":"descripcion",
            serie:"serie",
            observaciones:"observaciones",
            "edificio":"edificio",
            "estatus":"estatus",
            "planta_referencia":"planta_referencia",
        },
        
        camposLayout: [{
            pedimento: "[No de Pedimento. Ej. 370-3668-9000123]",
            "año":"[Año de pago del pedimento - 4 digitos]]",            
            "no_maquina":"[Número de Maquina]",
            "linea":"[Línea]",
            marca:"[Marca del activo - Opcional]",
            modelo:"[Modelo del activo - Opcional]",
            descripcion:"[Descripción del activo - Opcional]",
            serie:"[No. de Serie del activo - Opcional]",
            observaciones:"[Observaciones - Opcional]",
            edificio:"[Edificio]",
            estatus:"[Estatus ACTIVO/INACTIVO]",
            planta_referencia:"[Planta/Referencia]"
        }],        
        camposObligatorios: [
            "pedimento",
            "año",
            "no_maquina", "linea",
            "edificio", "estatus",
            "planta_referencia"
        ],        
    }),
    methods: {
        updateSize() {
            // Convierte los valores de entrada de texto a números decimales
            const w = parseFloat(this.width);
            const h = parseFloat(this.height);
            const mt = parseFloat(this.marginTop);
            const mb = parseFloat(this.marginBottom);
            const ml = parseFloat(this.marginLeft);
            const mr = parseFloat(this.marginRight);
            // Convierte los centímetros a píxeles (usando 72 ppp como aproximación)
            const pixelsPerCm = 72 / 2.54; // 96 ppp / 2,54 cm por pulgada            

            this.widthPX = Math.round(w * pixelsPerCm);
            this.heightPX = Math.round(h * pixelsPerCm);
            this.marginTopPX = Math.round(mt * pixelsPerCm);
            this.marginBottomPX = Math.round(mb * pixelsPerCm);
            this.marginLeftPX = Math.round(ml * pixelsPerCm);
            this.marginRightPX = Math.round(mr * pixelsPerCm);            
        },
        validaPassword: function(val){
            if(val && val!=""){
                if(val.toString().length < 4 || val.toString().length > 10){
                    return "Debe tener entre 4 y 10 caracteres"
                }
            }
            return true;
        },
        confirma_guardar_codigo: function(opcion=1){
            if(opcion == 1){ //requiere password
                if(!this.password || this.password=="" || this.validaPassword(this.password)!== true){
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "El código debe tener entre 4 y 10 caracteres. Favor de verificar",
                        footer: "",
                    });
                    return false;
                } else {
                    this.$swal({
                        type: "info",
                        title: "Importante",
                        text: "El código se pedirá al visualizar expediente usando el QR. ¿Desea continuar?",
                        footer: "",
                        showCancelButton: true,
                        cancelButtonColor: "#d33",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Aceptar",
                        cancelButtonText: "Cancelar"
                    }).then(result => {
                        if (result.value) {
                            this.guardar_codigo(opcion);
                        }
                    });
                }
            } else {
                this.$swal({
                        type: "info",
                        title: "Importante",
                        text: "Ya no se pedirá código al visualizar expediente usando QR. ¿Desea continuar?",
                        footer: "",
                        showCancelButton: true,
                        cancelButtonColor: "#d33",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Aceptar",
                        cancelButtonText: "Cancelar"
                    }).then(result => {
                        if (result.value) {
                            this.guardar_codigo(opcion);
                        }
                    });
            }
        },

        get_codigo:function(){
            let datos = {
                "rfc": this.$local_storage.get("rfc")
            }
            axios.post(this.$hostname + "reportes_ws/get_etiquetas_pass/", datos)            
                .then((res) => {
                    if(res.data && res.data.pass){
                        this.password = res.data.pass;
                    }
                }).catch(error => {
                    console.log(error);                    
                });
        },

        guardar_codigo: function(opcion=1){
            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            if(opcion == 0)
                this.password = "";
            let datos = {
                "rfc": this.$local_storage.get("rfc"),
                "usuario": this.$local_storage.get("id_usuario"),
                "password": this.password
            }
            axios.post(this.$hostname + "reportes_ws/save_etiquetas_pass/", datos)            
                .then((res) => {
                    if(opcion == 1){
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El código de accesos se estableció correctamente",
                            footer: ""
                        });
                    }else {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El código de accesos se eliminó correctamente",
                            footer: ""
                        });
                    }
                }).catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al guardar código. Intente nuevamente.",
                        footer: "",
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();                    
                });


        },
        validaFecha: function(fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida."
            else
                return true;
        },
        validaAnio: function() {
            if (this.model_busqueda.fecha_de != "" && this.model_busqueda.fecha_a != "") {
                var inicio = moment(this.model_busqueda.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model_busqueda.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial."
            }
            return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        
        beforeUpload(file) {
            var self = this;
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                self.file_adjunto = file;
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            self.file_adjunto = null;
            return false;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },        
        validaEntero(numero){
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },
     
        
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
                
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 500){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 500, favor de verificar.";                
                } else {
                    for (var k in results) {                                                

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            
                            if(!this.validarPatronPedimento(results[k]['pedimento'])){
                                errores++;
                                errorTmp = '<br/>' + "- El número '" + results[k]['pedimento'] + "' no es un pedimento válido. Ej. 240-1234-9000123";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(results[k]['estatus'] != undefined){
                                results[k]['estatus'] = results[k]['estatus'].toString().trim().toUpperCase();
                                if(!["ACTIVO","INACTIVO"].includes(results[k]['estatus'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- El estatus debe ser ACTIVO o INACTIVO";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }

                            if(results[k]['planta_referencia'] != undefined){
                                results[k]['planta_referencia'] = results[k]['planta_referencia'].toString().trim().toUpperCase();
                                if(!thisObject.plantas_arr.includes(results[k]['planta_referencia'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- La planta_referencia "+results[k]['planta_referencia']+" debe estar en el catálogo de Plantas/Referencias";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }
                                                     
                            if(!this.validaEntero(results[k]['año'])){
                                errores++;
                                errorTmp = '<br/>' + "- El año '" + results[k]['año'] + "' debe ser un año válido";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else if (parseInt(results[k]['año'])<1950 || parseInt(results[k]['año'])>2100) {
                                errores++;
                                errorTmp = '<br/>' + "- El año '" + results[k]['año'] + "' debe ser un año válido";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['año'] = parseInt(results[k]['año']);
                            }                                                        

                        }
                        
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {            
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {                
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var rfc = this.$local_storage.get("rfc");
                    for (var k in results) {  
                        this.importData.push({  
                            rfc: rfc, 
                            pedimento: results[k]['pedimento'],
                            anio: results[k]['año'],
                            no_maquina: results[k]['no_maquina'].toString(),
                            linea: results[k]['linea'].toString(),
                            marca: results[k]['marca']!=null ? results[k]['marca'].toString() : "",
                            modelo: results[k]['modelo']!=null ? results[k]['modelo'].toString() : "",
                            descripcion: results[k]['descripcion']!=null ? results[k]['descripcion'].toString() : "",
                            serie: results[k]['serie']!=null ? results[k]['serie'].toString() : "",
                            observaciones: results[k]['observaciones']!=null ? results[k]['observaciones'].toString() : "",
                            edificio: results[k]['edificio'].toString(),
                            estatus: results[k]['estatus'],
                            planta_referencia: results[k]['planta_referencia'],                            
                        });
                    }
                    var datos = {
                        rfc: rfc,                        
                        pedimentos: this.importData,
                        usuario: this.$local_storage.get("id_usuario"),
                    }                    
                    
                    axios.post(this.$hostname + "reportes_ws/etiquetas_bosch/", datos)                    
                        .then((res) => {
                            
                            let data = {
                                rfc: datos["rfc"],
                                usuario: datos["usuario"],
                                reporte_url: "/reportes_ws/qr_bosch/",
                                nombre_reporte: "Etiquetas QR Activo Fijo",
                                tipo: 'Etiquetas QR Activo Fijo Bosch',
                                "id_etiquetas": res.data["id_etiquetas"],
                                "id_reporte": res.data["id_etiquetas"],
                            };

                            axios({
                                method: "post",
                                url: this.$hostname + "reportes/save_reporte/",                                
                                data: data
                            })
                            .then(response => {                                
                                this.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
                                    footer: ""
                                });
                            })
                            .catch(error => {
                                let mensaje;
                                var titulo = "¡Operación no Permitida!";
                                var tipo = "error";
                                if (typeof error.response !== "undefined") {
                                    mensaje = error.response.data.mensaje;
                                    if (error.response.status == 406){
                                        titulo = "¡Ya existe un reporte en proceso!";
                                        tipo = "info";
                                    }
                                } else {
                                    mensaje = "Ocurrió un error al generar el reporte. Favor de intentar nuevamente.";
                                }
                                this.$swal({
                                    type: tipo,
                                    title: titulo,
                                    text: mensaje,
                                    footer: ""
                                });
                            }).then(() => {
                                this.$root.$dialogLoader.hide();   
                                this.guardar_plantilla_s3(res.data["id_etiquetas"]);                             
                                this.cargar();                                
                            });

                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de intentar nuevamente.",
                                footer: ""
                            });
                            this.$root.$dialogLoader.hide();                            
                            this.cargar();
                        });
                    
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        guardar_plantilla_s3: function(id_etiqueta){
            var self = this;
            var rfc = this.$local_storage.get("rfc"); 
            var keyFile = rfc + "/plantillas_activo_fijo/"+ id_etiqueta.toString() + "_"+ self.file_adjunto.name;
                    
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: self.file_adjunto.type
            }
            axios.post(self.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, self.file_adjunto, {headers:{'Content-Type': self.file_adjunto.type}})
                        .then((res) => { 
                            console.log("Archivo cargado correctamente a S3");
                        })                            
                        .catch((error)=>{                                                        
                            console.log("Error al cargar a S3: ", error);
                        });
                        
                    } else {
                        console.log("Undefined url de carga S3: ", res.data);
                    }
                })
                .catch((error) => {
                    console.log("Error al obtener url de carga S3: ", error);
            });
        },

        descarga_zip_plantillas:function(){
            var self = this;            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var datos_zip = {
                rfc: this.$local_storage.get("rfc"),
                usuario: this.$local_storage.get("id_usuario")
            }
            
            
            axios.post(self.$hostname + 'reportes_ws/zip_plantillas_af/', datos_zip)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var key_zip = res.data.mensaje;
                        console.log(key_zip);
                        
                        var datos = {
                            id: key_zip,
                            bucket: "production.econnect.ds"
                        }
                        axios.post(this.$hostname + 's3/download_url/', datos)
                            .then((res) => {
                                if (typeof res.data !== 'undefined') {
                                    var a = document.createElement("a");
                                    document.body.appendChild(a);
                                    a.style = "display: none";
                                    a.href = res.data.mensaje;
                                    a.target = '_blank';
                                    a.click();
                                    a.parentNode.removeChild(a);

                                } else {
                                    this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                    footer: '',
                                    });
                                }
                            })
                            .catch((error) => {
                                var mensaje = "Ocurrió un error al descargar el archivo";
                                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                    mensaje = error.response.data.mensaje;
                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: mensaje,
                                    footer: '',
                                });
                                console.log(error);
                            }).then(() => {
                                this.$root.$dialogLoader.hide();
                            });
                        
                    } else {
                        console.log(res.data);
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al generar el ZIP. Intente nuevamente.",
                            footer: '',
                        });
                        this.$root.$dialogLoader.hide();
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al generar el ZIP. Intente nuevamente.",
                        footer: '',
                    });
                    this.$root.$dialogLoader.hide();
            });
        },  
        cargar: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get('rfc'),
                tipo: 'Etiquetas QR Activo Fijo Bosch'
            };
            axios.post(this.URL + "get_reportes/", data)
            .then(res => {
            if (typeof res.data !== "undefined") {
                this.datos = res.data;
                this.datos.sort(function(a, b) {
                    //Ordenar por fecha más reciente
                    return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                });
                for (var k in this.datos) {
                    this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                    this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                    this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);                    
                }
            }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los registros. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        getEstatus: function(estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getTablaPedimentos: function(id_reporte){
           this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get('rfc'),
                id_reporte: id_reporte
            };

            axios.post(this.$hostname + "reportes_ws/get_etiquetas_bosch/", data)            
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.data_resumen = res.data;  
                    for (var k in this.data_resumen) {
                        this.data_resumen[k].fecha_pago_real = this.parseDate(this.data_resumen[k].fecha_pago_real);
                        this.data_resumen[k].fecha_entrada = this.parseDate(this.data_resumen[k].fecha_entrada);                        
                    }   
                    this.modal_pedimentos = true;           
                }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al obtener los pedimentos. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();                        
                    });
              }
          });
        },
        downloadReporte: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = '_blank';
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                    footer: '',
                    });
                }
                })
                .catch((error) => {
                var mensaje = "Ocurrió un error al descargar el archivo";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                    mensaje = error.response.data.mensaje;
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: '',
                });
                console.log(error);
                }).then(() => {
                this.$root.$dialogLoader.hide();
                });
            },

            cargar_plantas:function(){
                this.loadingPlantas = true;
                var datos = {
                    cliente: this.$local_storage.get("id_cliente")
                };
                //axios.post(this.$hostname + 'reportes_ws/load_plantas_bosch/', datos) 
                axios.post(this.$hostname + 'catalogos/referencias/get_referencias/', datos) 
                .then((res) => {                                    
                    this.plantas_arr = res.data.map( e => e.referencia);
                }).catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al cargar las Plantas.",
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.loadingPlantas = false;
                });
            },
            cargar_edificios:function(){
                this.loadingEdificios = true;
                axios.post(this.$hostname + 'reportes_ws/load_edificios_bosch/', {"rfc":this.$local_storage.get("rfc")})                
                .then((res) => {                
                    this.edificios_arr = res.data;                    
                }).catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al cargar los Edificios.",
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.loadingEdificios = false;
                });
            },
            cargar_lineas:function(){
                this.loadingLineas = true;
                axios.post(this.$hostname + 'reportes_ws/load_lineas_bosch/', {"rfc":this.$local_storage.get("rfc")})                
                .then((res) => {                
                    this.lineas_arr = res.data;                    
                }).catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al cargar las Líneas.",
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.loadingLineas = false;
                });
            },
            buscar:function(){
                let datos = {
                    rfc: this.$local_storage.get("rfc"),
                    edificio: this.model_busqueda.edificio!=null?this.model_busqueda.edificio:"",
                    fecha_a: this.model_busqueda.fecha_a!=null?this.model_busqueda.fecha_a:"",
                    fecha_de:this.model_busqueda.fecha_de!=null?this.model_busqueda.fecha_de:"",
                    linea: this.model_busqueda.linea!=null?this.model_busqueda.linea:"",
                    maquina: this.model_busqueda.maquina!=null?this.model_busqueda.maquina:"",
                    pedimento: this.model_busqueda.pedimento!=null?this.model_busqueda.pedimento:"",
                    planta: this.model_busqueda.planta!=null?this.model_busqueda.planta:"",
                };

                if(datos.edificio=="" && datos.fecha_a=="" && datos.fecha_de=="" && datos.linea=="" && datos.maquina==""
                    && datos.pedimento=="" && datos.planta==""){
                        this.$swal({
                            type: "warning",
                            title: "¡Seleccione al menos un filtro!",
                            text: "",
                            footer: '',
                        });    
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios.post(this.$hostname + 'reportes_ws/search_etiquetas_bosch/', datos)                    
                    .then((res) => {        
                        if(res.data.length> 0){
                            this.datos_etiquetas = res.data;
                            for (var k in this.datos_etiquetas) {
                                this.datos_etiquetas[k].fecha_pago_real = this.parseDate(this.datos_etiquetas[k].fecha_pago_real);
                                this.datos_etiquetas[k].fecha_entrada = this.parseDate(this.datos_etiquetas[k].fecha_entrada);
                                if( this.datos_etiquetas[k].solicitado){
                                    this.datos_etiquetas[k].solicitado = this.parseDate(this.datos_etiquetas[k].solicitado);    
                                }
                            }
                        }else {
                            this.datos_etiquetas = [];                            
                        }
                    }).catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al realizar la búsqueda. Intente nuevamnente.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });
                }
                
            },
            editar:function(row){
                this.model_editable = JSON.parse(JSON.stringify(row));
                this.modal = true;
            },
            guardar() {
                if (this.$refs.form.validate()) {

                    this.model_editable["rfc"] = this.$local_storage.get("rfc");

                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                                                          
                    axios.post(this.$hostname + 'reportes_ws/edit_etiqueta_bosch/', this.model_editable).then(res => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                            this.modal = false;                                        
                        })
                        .catch(error => {
                            var mensaje = "";
                            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                mensaje = error.response.data.mensaje;
                            
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de verificar",
                                footer: mensaje                                
                            });
                            console.log(error);                                       
                        }).then(()=>{                            
                            this.$root.$dialogLoader.hide();                            
                            this.buscar();
                        });
                }
            },
            downloadQr: function(row){
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    this.model_editable = JSON.parse(JSON.stringify(row));                    
                    axios.post(this.$hostname+ "reportes_ws/genera_qr_bosch/", row)
                        .then(res => {
                            this.codigo_qr = res.data;
                            this.leyenda_qr = "FAVOR NO REMOVER ETIQUETA";
                            this.leyenda_qr2 = "(ADUANAS)"
                            this.leyenda_planta = row.planta_referencia;
                            this.leyenda_maquina = row.no_maquina;
                            this.updateSize();
                            this.modal_qr = true;  
                        })
                        .catch(error => {
                            var mensaje = "";
                            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                mensaje = error.response.data.mensaje;
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al generar el QR. Intente nuevamente.",
                                footer: mensaje
                            });
                            console.log(error);                                       
                        }).then(()=>{                            
                            this.$root.$dialogLoader.hide();                                                                                    
                        });
            },
            descargar_qr:async function(){
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var self = this;
                this.borderCuadro = 0;
                let codigo = document.querySelector("#html_codigo_qr");

                //DESCARGALO COMO PDF
                /*var pdf = new jsPDF('p', 'pt');
                var name = self.model_editable.planta_referencia+"_"+self.model_editable.no_maquina +".pdf"
                    
                const options = {type: 'dataURL'};
                var url = await this.$html2canvas(codigo, options);

                pdf.setFontSize(20);
                pdf.addImage(url, 'PNG', 40, 40, 130, 180);
                pdf.save(name);
                self.$root.$dialogLoader.hide(); 
                */
        
                //DESCARGALO COMO PNG
                var url = await this.$html2canvas(codigo, {type: 'dataURL'});
                var anchorTag = document.createElement("a");
                document.body.appendChild(anchorTag);                    
                anchorTag.download = self.model_editable.planta_referencia+"_"+self.model_editable.no_maquina +".png";
                anchorTag.href = url;
                anchorTag.target = '_blank';
                anchorTag.click();
                self.$root.$dialogLoader.hide(); 
                this.borderCuadro = 1;

            },
        
    }, //methods

    created: function () {    
        this.URL = this.$hostname+"reportes/";        
        this.cargar();
        this.get_codigo();
        this.cargar_plantas();
        this.cargar_edificios();
        this.cargar_lineas();

    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }    

#html_codigo_qr {
  display: inline-block;
  height: auto;
}
#html_codigo_qr img {
  max-width: 100%;
}

</style>
